define(["jquery", "knockout", "@modules/content/helpfulBLockOverlay/helpfulBlockOverlayViewModel"], function ($, ko, HelpfulBlockOverlayViewModel) {
    if (window.scan && window.scan.helpfulContentBlock && $(".help-block-item-container").length > 0) {
        ko.applyBindings(new HelpfulBlockOverlayViewModel(), document.getElementsByClassName("help-block-item-container")[0]);
        $(".hide-load").removeClass("hide-load");
        $(".tool-load").removeClass("tool-load");
    }
});
